import styled, { css } from 'styled-components';
export const Code = styled.div`
    background-color: rgb(0, 30, 60);
    margin: 1rem;
    padding: 1rem;
    max-width: calc(50vw - 32px);
     display:flex;
    flex-direction: column;
    border-radius: 1rem;
    border: 1px solid rgb(19, 47, 76);
     color: rgb(252, 146, 158);
    overflow: auto;`
